import { render, staticRenderFns } from "./AdminOrder.vue?vue&type=template&id=cf1f2ff0"
import script from "./AdminOrder.vue?vue&type=script&lang=js"
export * from "./AdminOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf1f2ff0')) {
      api.createRecord('cf1f2ff0', component.options)
    } else {
      api.reload('cf1f2ff0', component.options)
    }
    module.hot.accept("./AdminOrder.vue?vue&type=template&id=cf1f2ff0", function () {
      api.rerender('cf1f2ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminOrder.vue"
export default component.exports